// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

// PrimeNG
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { InputOtpModule } from 'primeng/inputotp';

// Composants
import { FormBaseComponent } from 'src/app/@shared/components/abstract/form-base.component';

@Component({
    selector: 'app-mfa-verify-form',
    imports: [
        ReactiveFormsModule,
        AutoFocusModule,
        ButtonModule,
        InputOtpModule,
    ],
    templateUrl: './mfa-verify-form.component.html',
    styleUrls: ['./mfa-verify-form.component.scss']
})
export class MfaVerifyFormComponent extends FormBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Input() preAuthToken!: string;
    @Output() mfaSuccess = new EventEmitter<void>();
    @Output() sessionExpired = new EventEmitter<void>();

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override buildForm() {
        this.form = this.formBuilder.group({
            code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
        });
    }

    protected override subscribeToObservables(): void {
        this.subscriptions.add(
            this.form.get('code')?.valueChanges.subscribe(() => {
                if (this.form.get('code')?.valid) {
                    this._verify();
                }
            })
        );
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    private _setLoading(loading: boolean): void {
        this.loading = loading;
        if (loading) {
            this.form.disable({ emitEvent: false });
        } else {
            this.form.enable({ emitEvent: false });
        }
    }

    private _verify(): void {
        const code = this.form.get('code')?.value as string;
        this._setLoading(true);
        this.mfaService.verify$(code, this.preAuthToken)
            .pipe(finalize(() => this._setLoading(false)))
            .subscribe({
                next: () => this.mfaSuccess.emit(),
                error: (err: any) => {
                    if (err?.status === 401) {
                        this.sessionExpired.emit();
                    } else {
                        this.messageService.sendODataMessages(err.error?.messages);
                        this.form.get('code')?.reset();
                    }
                }
            });
    }
}
